import React from 'react'
import { makeLayout } from './styled'

export const RawLayout = makeLayout('div')

function Layout(props) {
  return <RawLayout {...props} />
}

export default Layout
